import React from "react";
import { Carousel, Col, Container, Row } from "react-bootstrap";
import pro2p2 from "../../../images/project2-p2.png";
import pro2p1 from "../../../images/project2-p1.png";
import pro2p3 from "../../../images/project2-p3.png";
const Project02 = () => {
  return (
    <Container className="font mt-5 mb-5">
      <h1 className="text-center  ">
        Travel<span className="heading"> Bizz</span>
      </h1>
      <Container className=" mt-5 p-5 project-bg project-container border border-4 border-info rounded  ">
        <Row>
          <p className="fw-bold text-center mb-4 head d-inline fs-2 ">
            Description
          </p>
          <Col sm={12} md={6} lg={6}>
            <h5 className="text-secondary">
              It is a Tourism Website. On this website, a user can book a Tour
              place to enjoy his vacation. Beside a user can read latest tour
              blogs. Here are more facilities for a user{" "}
            </h5>

            <li>
              Users and Admin can sign up and log in to this website using
              google or Email and password
            </li>
            <li>Admin can maintain the orders of users.</li>
            <li>
              Users can place booking, see his booking, and delete his booking.
            </li>
            <h5 className="mt-2">
              Frontend:{" "}
              <span>
                {" "}
                <span className="badge bg-info m-1">HTML 5</span>
                <span className="badge bg-info">CSS3</span>
                <span className="badge bg-info m-1 ">Bootstrap</span>
                <span className="badge bg-info">React.js</span>
                <span className="badge bg-info m-1">JavaScript(ES6)</span>
                <span className="badge bg-info m-1">React Router</span>
              </span>{" "}
            </h5>
            <h5 className="mt-2">
              Backend:
              <span>
                {" "}
                <span className="badge bg-info m-1">MongoDB</span>
                <span className="badge bg-info">Express.js</span>
              </span>{" "}
            </h5>

            <h5>
              Link:{" "}
              <span>
                <a
                  className="link-btn badge bg-info m-1"
                  href="https://travel-bizz.web.app/ "
                  target="_blank"
                  rel="noreferrer"
                >
                  Live
                </a>
                <a
                  className="link-btn badge bg-info m-1"
                  href="https://github.com/moshiur01/travel-bizz-client-side"
                  target="_blank"
                  rel="noreferrer"
                >
                  Client Side
                </a>
                <a
                  className="link-btn badge bg-info m-1"
                  href="https://github.com/moshiur01/travel-bizz-server-side-"
                  target="_blank"
                  rel="noreferrer"
                >
                  Server Side
                </a>
              </span>{" "}
            </h5>
          </Col>
          <Col sm={12} md={6} lg={6} className="my-auto">
            <Carousel className=" carousel-img  border rounded  border-3 border-info ">
              <Carousel.Item interval={1000}>
                <img
                  className="d-block w-100 img-fluid "
                  src={pro2p1}
                  alt="First slide"
                />
              </Carousel.Item>
              <Carousel.Item interval={1000}>
                <img
                  className="d-block w-100 img-fluid"
                  src={pro2p2}
                  alt="Second slide"
                />
              </Carousel.Item>
              <Carousel.Item interval={1000}>
                <img
                  className="d-block w-100 img-fluid"
                  src={pro2p3}
                  alt="Third slide"
                />
              </Carousel.Item>
            </Carousel>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Project02;
